// extracted by mini-css-extract-plugin
export default {"base":"AddEditSubscription_base__pLaL+","header":"AddEditSubscription_header__sb7Jh","content":"AddEditSubscription_content__eK767","body":"AddEditSubscription_body__R8Avp"};